import Accounts from './account'
import Users from './users'

const modules = {
    Accounts,
    Users
}

const state = {}

const mutations = {}
const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    modules
}
